import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SessionManager = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60); // Cuenta regresiva de 60 segundos

  useEffect(() => {
    const sessionDuration = 14100000; // 3 horas y 55 minutos en milisegundos
    const warningTime = sessionDuration - 60000; // 1 minuto antes de cerrar sesión
    let logoutTimer, countdownTimer;

    // Obtener el timestamp de inicio de sesión
    let sessionStart = localStorage.getItem("session_start");

    if (!sessionStart) {
      // Si no existe, guardamos el timestamp actual
      sessionStart = Date.now();
      localStorage.setItem("session_start", sessionStart);
    } else {
      sessionStart = parseInt(sessionStart, 10);
    }

    const timeElapsed = Date.now() - sessionStart;
    const timeRemaining = sessionDuration - timeElapsed;

    if (timeRemaining <= 0) {
      // Si ya pasaron las 3 horas, cerrar sesión inmediatamente
      cerrarSesion();
      return;
    }

    if (timeRemaining <= 60000) {
      // Si queda menos de 1 minuto, mostrar el modal y empezar la cuenta regresiva
      setShowModal(true);
      startCountdown();
    } else {
      // Programar el aviso 1 minuto antes del cierre de sesión
      logoutTimer = setTimeout(() => {
        setShowModal(true);
        startCountdown();
      }, timeRemaining - 60000);
    }

    function startCountdown() {
      setTimeLeft(60);
      countdownTimer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(countdownTimer);
            cerrarSesion();
          }
          return prev - 1;
        });
      }, 1000);
    }

    function cerrarSesion() {
      localStorage.clear();  // Borra todos los datos del usuario
      navigate("/");         // Redirige a la pantalla de inicio
      window.location.reload(); // Recarga la página
    }

    return () => {
      clearTimeout(logoutTimer);
      clearInterval(countdownTimer);
    };
  }, [navigate]);

  return (
    <>
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <h2>⚠️ Aviso de cierre de sesión automático ⚠️</h2>
            <p>Tu sesión está a punto de expirar. Se cerrará automáticamente en <b>{timeLeft} segundos</b>.</p>
          </div>
        </div>
      )}
    </>
  );
};

// Estilos del modal
const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2000
};

const modalStyle = {
  background: "white",
  padding: "20px",
  borderRadius: "10px",
  textAlign: "center",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)"
};

export default SessionManager;
